import styled from 'styled-components';

export const MenubarItemSeparator = styled.div`
  width: 100%;
  height: 1px;
  margin: 5px 0;

  background-color: var(--neutral-3);
`;
